// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { NetblockWhoisSchema } from './NetblockWhoisSchema'
import type { NetblockWhois } from './NetblockWhoisSchema'
import { NetblockEvidenceSchema } from './NetblockEvidenceSchema'
import type { NetblockEvidence } from './NetblockEvidenceSchema'
import { HostWithRelationsSchema } from './HostRelationsSchema'
import type { HostWithRelations } from './HostRelationsSchema'
import { NetBlockSchema } from './NetBlockSchema';

/////////////////////////////////////////
// NET BLOCK RELATION SCHEMA
/////////////////////////////////////////

export type NetBlockRelations = {
  surface: ExternalNetworkWithRelations;
  parent?: NetBlockWithRelations | null;
  children: NetBlockWithRelations[];
  whois?: NetblockWhois | null;
  evidences: NetblockEvidence[];
  hosts: HostWithRelations[];
};

export type NetBlockWithRelations = z.infer<typeof NetBlockSchema> & NetBlockRelations

export const NetBlockWithRelationsSchema: z.ZodType<NetBlockWithRelations> = NetBlockSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  parent: z.lazy(() => NetBlockWithRelationsSchema).nullable(),
  children: z.lazy(() => NetBlockWithRelationsSchema).array(),
  whois: z.lazy(() => NetblockWhoisSchema).nullable(),
  evidences: z.lazy(() => NetblockEvidenceSchema).array(),
  hosts: z.lazy(() => HostWithRelationsSchema).array(),
}))